import React from "react";
import PanelHead from "../../UI/Panel/PanelHead";
import PanelBody from "../../UI/Panel/PanelBody";
import PanelsTable from "../../UI/Panels/PanelsTable";

const Panels = () => {
  return (
    <div>
      <PanelHead title="Panels" />
      <PanelBody content={<PanelsTable />} />
    </div>
  );
};

export default React.memo(Panels);
